import {
  getSessionItem,
  SessionStorageKeys,
  setSessionItem
} from '@kurotetsu/agent/utils/sessionStorage';
import { firebaseAuth } from '@kurotetsu/agent/vendors/firebase';
import { AUTH_PATH, USER_PATH } from '@kurotetsu/share/apis/apiPaths';
import {
  configureFetchWithAuth,
  fetchWithAuth
} from '@kurotetsu/share/apis/fetchWithAuth';

export const API_ENV = import.meta.env.VITE_APP_ENV;
export const API_TTRS_HOST = import.meta.env.VITE_API_TTRS_HOST as string;
// local / remotetest モードでは Vite のプロキシ経由（相対パス）とする。
export const IS_LOCAL = API_ENV === 'local' || API_ENV === 'remotetest';

configureFetchWithAuth({
  apiEnv: API_ENV,
  apiHost: API_TTRS_HOST,
  getToken: () => getSessionItem<string>(SessionStorageKeys.ID_TOKEN),
  setToken: token => setSessionItem(SessionStorageKeys.ID_TOKEN, token),
  getFreshToken: async () => firebaseAuth.currentUser?.getIdToken(true) ?? null,
  noAuthPaths: [`${USER_PATH}/password-reset`, AUTH_PATH]
});

export { fetchWithAuth };
